<template>

  <div id="app" :class="{ 'dark-mode' : darkMode }">
  <router-view/>

  <!-- <div class="changeMode"> -->

    <div class="containerChange" @click="changeDarkMode" :class="{ 'changed' : darkMode }">

      <div class="sunMoon">
        <div class="sun" :class="{ 'moved' : darkMode }"></div>
        <div class="moon" :class="{ 'visible' : darkMode }">
          <div class="rondMoon rondM1"></div>
          <div class="rondMoon rondM2"></div>
          <div class="rondMoon rondM3"></div>
        </div>
      </div>
      <div class="rayons" :class="{ 'moved' : darkMode }">
        <div class="rayon rayon1"></div>
        <div class="rayon rayon2"></div>
        <div class="rayon rayon3"></div>
      </div>
      <div class="nuagesFront">
        <div class="nuageF nuage1"></div>
        <div class="nuageF nuage2"></div>
        <div class="nuageF nuage3"></div>
        <div class="nuageF nuage4"></div>
        <div class="nuageF nuage5"></div>
      </div>
      <div class="nuagesBack">
        <div class="nuageB nuage6"></div>
        <div class="nuageB nuage7"></div>
        <div class="nuageB nuage8"></div>
        <div class="nuageB nuage9"></div>
        <div class="nuageB nuage10"></div>
      </div>

    </div>

  </div>
  <!-- </div> -->
</template>

<script>
export default {

  data(){
    return {
      // darkMode: false,
    }
  },

  methods: {
    changeDarkMode(){
      // this.darkMode = !this.darkMode;
      this.$store.commit('setDarkMode');
    }
  },

  computed: {
    darkMode(){
      return this.$store.state.darkMode
    }
  },
}


</script>


<style>


#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#app.dark-mode{
  background-color: #000200;
  color: #fff;
}

*, ::before, ::after{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.containerChange{
  position: fixed;
  top: 90%;
  left: 88%;
  width: 140px;
  height: 50px;
  background-color: #086DD2;
  border-radius: 200px;
  overflow: hidden;
  box-shadow: 5px 5px 10px;
  transition: background-color 0.3s ease;
  z-index: 1000;
}

.containerChange.changed{
  background-color: #000000;
}

/* Mobile */
@media (max-width: 480px){
  .containerChange{
    left: 70%;
    width: 100px;
    height: 40px;
  }
}

/* Tablette */
@media screen and (min-width: 481px) and (max-width: 768px) {

  .containerChange{
    left: 85%;
    top: 88%;
    width: 100px;
    height: 40px;
  }
}



.containerChange .sunMoon{
  position: absolute;
  display: flex;
  cursor: pointer;

}

.containerChange .sun{
  width: 40px;
  height: 40px;
  background-color: #FDB813;
  border-radius: 50%;
  display: flex;
  position: absolute;
  margin-left: 10px;
  margin-top: 5px;
  z-index: 2;

}

/* Mobile */
@media (max-width: 480px){

  .containerChange .sun{
  width: 25px;
  height: 25px;
  margin-top: 8px;
  margin-left: 10px;

  }

}


/* Tablette */
@media screen and (min-width: 481px) and (max-width: 768px) {

  .containerChange .sun{
  width: 30px;
  height: 30px;
  margin-top: 0.4rem;
  }
}


.containerChange .sun.moved{
  margin-left: 80px;
  display: none;
  z-index: -1;
}

.containerChange .moon{
  width: 40px;
  height: 40px;
  background-color: #CCCCCC;
  border-radius: 50%;
  display: none;
  position: absolute;
  margin-left: 90px;
  margin-top: 5px;
  z-index: -1;
}

@media (max-width: 480px){

}

.containerChange .moon .rondMoon{
  width: 10px;
  height: 10px;
  background-color: grey;
  border-radius: 50%;

}

@media (max-width: 480px){
  .containerChange .moon .rondMoon{
    width: 7px;
    height: 7px;
  }
}

.containerChange .moon .rondMoon.rondM1{
  margin-left: 10px;
  margin-top: 10px;
  width: 5px;
  height: 5px;
}

.containerChange .moon .rondMoon.rondM2{
  margin-top: 23px;
  margin-left: -2px;
}

.containerChange .moon .rondMoon.rondM3{
  margin-top: 13px;
  margin-left: 4px;
  width: 7px;
  height: 7px;
}

/* Mobile */

@media (max-width: 480px){
  .containerChange .moon{
    width: 25px;
    height: 25px;
    margin-top: 8px;
    margin-left: 70px;
  }

  .containerChange .moon .rondMoon{
    width: 7px;
    height: 7px;
  }

  .containerChange .moon .rondMoon.rondM1{
    margin-top: 13px;
    margin-left: 4px;
    width: 6px;
    height: 6px;
  }

  .containerChange .moon .rondMoon.rondM2{
    margin-top: 2px;
    margin-left: -2px;
  }

  .containerChange .moon .rondMoon.rondM3{
    margin-top: 13px;
    margin-right: 3px;
    width: 6px;
    height: 6px;
  }
}

/* Tablette */

@media screen and (min-width: 481px) and (max-width: 768px) {

  .containerChange .moon{
    width: 30px;
    height: 30px;
    margin-top: 0.4rem;
    margin-left: 65px;
  }

  .containerChange .moon .rondMoon{
    width: 7px;
    height: 7px;
  }

  .containerChange .moon .rondMoon.rondM1{
    margin-top: 15px;
    margin-left: 4px;
  }

  .containerChange .moon .rondMoon.rondM2{
    margin-top: 2px;
    margin-left: 2px;
  }

  .containerChange .moon .rondMoon.rondM3{
    margin-top: 15px;
    margin-right: 3px;
  }

}

.containerChange .moon.visible{
  display: flex;
  z-index: 2;
  
}


.rayons{
  position: absolute;
  display: flex;
  z-index: 1;
  
}

.rayons.moved{
  margin-left: 100px;
  
}

.rayon{
  position: absolute;
  border-radius: 50%;
}

.rayon.rayon1{
  position: relative;
  width: 90px;
  height: 90px;
  margin-left: -20px;
  margin-top: -20px;
  background-color: #FFFFFF;
  opacity: 0.1;
  z-index: -1;
}

.rayon.rayon2{
  position: relative;
  width: 130px;
  height: 130px;
  margin-left: -110px;
  margin-top: -40px;
  background-color: #FFFFFF;
  opacity: 0.1;
  z-index: -1;
}

.rayon.rayon3{
  position: relative;
  width: 170px;
  height: 170px;
  margin-left: -150px;
  margin-top: -60px;
  background-color: #FFFFFF;
  opacity: 0.1;
  z-index: -1;
}

/* Mobile */
@media (max-width: 480px){
  .rayon.rayon1{
    width: 50px;
    height: 50px;
    margin-left: -6px;
    margin-top: -6px;
  }

  .rayon.rayon2{
    width: 70px;
    height: 70px;
    margin-left: -50px;
    margin-top: -12px;
  }
}

/* Tablette */
@media screen and (min-width: 481px) and (max-width: 768px) {

  .rayon.rayon1{
    width: 70px;
    height: 70px;
    margin-left: -16px;
    margin-top: -14px;
  }

  .rayon.rayon2{
    width: 100px;
    height: 100px;
    margin-left: -85px;
    margin-top: -30px;
  }

  .rayon.rayon3{
    width: 130px;
    height: 130px;
    margin-left: -115px;
    margin-top: -40px;
  }
  
  }

.nuagesFront{
  position: absolute;
  display: flex;
}

.nuageF{
  position: absolute;
  background-color: #FFFFFF;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  z-index: -1;
}

.nuageF.nuage1{
  margin-left: 120px;
  margin-top: 10px;
}

.nuageF.nuage2{
  margin-left: 100px;
  margin-top: 30px;
}

.nuageF.nuage3{
  margin-left: 70px;
  margin-top: 30px;
}

.nuageF.nuage4{
  margin-left: 40px;
  margin-top: 30px;
}

.nuageF.nuage5{
  margin-left: 20px;
  margin-top: 40px;
}

/* Mobile */
@media (max-width: 480px){
  .nuageF{
    width: 20px;
    height: 20px;
  }

  .nuageF.nuage1{
    margin-left: 84px;
    margin-top: 10px;
  }

  .nuageF.nuage2{
    margin-left: 78px;
    margin-top: 20px;
  }

  .nuageF.nuage3{
    margin-left: 65px;
    margin-top: 24px;
  }

  .nuageF.nuage4{
    margin-left: 48px;
    margin-top: 28px;
  }

  .nuageF.nuage5{
    margin-left: 32px;
    margin-top: 35px;
  }
}

/* Tablette */
@media screen and (min-width: 481px) and (max-width: 768px) {
  .nuageF{
    width: 20px;
    height: 20px;
  }

  .nuageF.nuage1{
    margin-left: 85px;
    margin-top: 20px;
  }

  .nuageF.nuage2{
    margin-left: 70px;
    margin-top: 25px;
  }

  .nuageF.nuage3{
    margin-left: 55px;
    margin-top: 35px;
  }  

  .nuageF.nuage4{
    margin-left: 38px;
    margin-top: 34px;
  }

  .nuageF.nuage5{
    display: none;
  }
  }



.nuagesBack{
  position: absolute;
  display: flex;
}

.nuageB.nuage6{
  margin-left: 115px;
  margin-top: 5px;
}

.nuageB.nuage7{
  margin-left: 100px;
  margin-top: 20px;
}

.nuageB.nuage8{
  margin-left: 70px;
  margin-top: 22px;
}

.nuageB.nuage9{
  margin-left: 40px;
  margin-top: 25px;
}

.nuageB.nuage10{
  margin-left: 15px;
  margin-top: 35px;
}

@media (max-width: 480px){
  .nuagesBack.nuage7{
    color: pink;
    margin-left: 10px;
    margin-top: 5px;
  }


}

/* hover */


.containerChange:hover .sun{
  margin-left: 20px;
}

.containerChange:hover .rayons{
  margin-left: 10px;
}

.containerChange:hover .moon{
  margin-left: 80px;
}

.containerChange:hover .rayons.moved{
  margin-left: 90px;
}

/* clique darkMode */





</style>
